// Fetches the three documents the Workout view is built from. Kept out of the
// component so it can be tested without a browser (packages/api/test/docpaths).
// The paths, and the fallback from the new location to the old, are in
// ../docPaths.ts.
import { readLifeDoc, type ReadDoc } from "../docPaths.ts";

export interface WorkoutSources { programme: string; core: string; exercises: string }

export async function loadWorkoutSources(read: ReadDoc): Promise<WorkoutSources> {
  const [programme, core, exercises] = await Promise.all([
    readLifeDoc(read, "workout", "programme.md"),
    readLifeDoc(read, "workout", "core.md"),
    readLifeDoc(read, "workout", "exercises.md"),
  ]);
  return { programme: programme.content, core: core.content, exercises: exercises.content };
}
